module.exports = __webpack_public_path__ + "media/common/statics/syota-1803cde3f74ba863124c0a6f5edd00ab.png";